import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';

import CommonUiIcon from 'webapp/components/common/ui-icon';

interface CustomQuerySetupWizardSheetNavigationComponentInterface {
	Args: {
		steps: SomeDataObject[];
		open: (stepId: string) => void;
	};
}

const CustomQuerySetupWizardSheetNavigationComponent: TOC<CustomQuerySetupWizardSheetNavigationComponentInterface> =
	<template>
		<nav>
			<ul>
				{{#each @steps as |step|}}
					<li class={{if step.isActive "active" (if step.isDone "done" "undone")}}>
						{{#if step.isDone}}
							<CommonUiIcon @name="Check" @size="xs" @class="done-icon" />
						{{/if}}
						<a {{on "click" (fn @open step.id)}}>{{step.text}}</a>
					</li>
				{{/each}}
			</ul>
		</nav>
	</template>;

export default CustomQuerySetupWizardSheetNavigationComponent;
